import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'es6-promise-always';
import '@roo/roo/theme/default/index.css';
import 'RooV1.12/theme/default/tableNew.min.css';
import './assets/styles/index.scss';
import dva from './dva';
import appModel from './models';
import App from './App';

const dvaApp = dva.createApp({
    initialState: {
        provider: {
            user: {
                data: {},
            },
        },
    },
    models: appModel,
    onError(e: any) {
        console.error('--- dva error ---: ', e);
    },
});
const store = dvaApp.getStore();

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root'),
);
